var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionContent',{attrs:{"id":"SectionGuarantees","background":"blue","content":_vm.$t('content'),"cta":_vm.$t('cta'),"ctaTo":_vm.ctaTo,"icon":"handshake-shield","isVertical":false,"title":_vm.$t('title')}})
}
var staticRenderFns = []

export { render, staticRenderFns }